/* eslint-disable */
import axios from "axios";

export default {
  namespaced: true,
  state: {
    token: "",
    user: {},
    company: {},
    roleName: "",
  },
  getters: {
    authenticated(state) {
      return state.token ? true : false;
    },
    user(state) {
      return state.user;
    },
    company(state) {
      return state.company;
    },
    roleName(state) {
      return state.user.roles[0].name;
    },
  },
  mutations: {
    SET_TOKEN(state, data) {
      state.token = data;
    },
    SET_USER(state, data) {
      state.user = data;
      // let userCompanies = data ? data.companies : "";
      // state.company = userCompanies.length ? userCompanies[0] : {};
    },
    SET_COMPANY(state, company) {
      state.company = company;
      localStorage.setItem("company", JSON.stringify(company)); // This is when the Super Admin Selects a Company from the dropdown
      if (company != null && company.id) {
        axios.defaults.headers.common["company-id"] = company.id;
      } else axios.defaults.headers.common["company-id"] = null;
    },
  },
  actions: {
    async logIn({ dispatch }, credentails) {
      console.log('credentails', credentails)
      const response = await axios.post("/test_login", credentails);
      if(response?.data?.token != null){
        await dispatch("attempt", response.data.token);
        return response
      }else{
        return response
      }
    },
    async attempt({ state, commit }, token) {
            console.log('token' , token)
      if (token) commit("SET_TOKEN", token);

      if (!state.token) return;

      try {
        const response = await axios.get("/me");
        console.log('response' , response.data.data)
        commit("SET_USER", response.data.data);
        // var company = JSON.parse(localStorage.getItem("company"));
        // if (company) commit("SET_COMPANY", company);
      } catch (e) {
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
        commit("SET_COMPANY", null);
      }
    },
    logOut({ commit }) {
      console.log('logOut')
      commit("SET_TOKEN", null);
      commit("SET_USER", null);
    },
    setCompany({ commit }, company) {
      commit("SET_COMPANY", company);
    },
  },
};
